module.exports = __webpack_public_path__ + "img/galeria-forestales-1.af62db98.jpg";